import React, { useContext } from 'react';
import { useHistory } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faLightbulbOn, faTasks } from '@fortawesome/pro-solid-svg-icons';

import { TvPlanContext } from "../../contexts/tvplancontext";
import AppxLangAvatar from "../AppxLangAvatar";
import Price from "../Price";

import './index.css';


export default function TvDrawer(props) {
    const { t } = useTranslation('tvplan');
    const ctx = useContext(TvPlanContext);
    const org = ctx.getOrg();
    const lang = ctx.getLang();
    const plan = ctx.getPlan();
    const planPrice = parseFloat(plan?.monthlyPrice) || 0;
    const history = useHistory();
    const helpClick = () => ctx.toggleHelp();
    const channelListClick = () => history.push(`/${org}/list`);

    return (
        <div className="tv-drawer">
            {props.showGroupTip && (
            <div className="tv-group-add-tip-container">
                <div className="tv-group-add-tip">
                    <div className="tv-group-add-tip-corner-bg"></div>
                    <div className="tv-group-add-tip-count">
                        {props.groupCount}<span className="tv-group-tip-plus">+</span>
                    </div>
                    <div className="tv-group-add-tip-text">
                        {lang === 'fr' ? (
                        <span className="tv-group-add-tip-text1">
                            <span className="tv-group-add-tip-add">{t('TvDrawer.add')}</span>
                            <span className="tv-group-add-tip-missing">{props.pickMoreForDiscountCount}</span>
                            <span className="tv-group-add-tip-chs">{t('TvDrawer.ch')}</span> {t('TvDrawer.to_get_a')} <span className="tv-group-add-tip-discount">{t('TvDrawer.discount')}</span><span className="tv-group-add-tip-group">{t('TvDrawer.group')}</span>
                        </span>
                        ) : (
                        <span className="tv-group-add-tip-text1">
                            <span className="tv-group-add-tip-add">{t('TvDrawer.add')}</span>
                            <span className="tv-group-add-tip-missing">{props.pickMoreForDiscountCount}</span>
                            <span className="tv-group-add-tip-chs">{t('TvDrawer.ch')}</span> {t('TvDrawer.to_get_a')} <span className="tv-group-add-tip-group">{t('TvDrawer.group')}</span> <span className="tv-group-add-tip-discount">{t('TvDrawer.discount')}</span>
                        </span>
                        )}
                    </div>
                </div>
                <div className="tv-group-add-tip-icon">
                    <FontAwesomeIcon icon={faLightbulbOn} />
                </div>
            </div>
            )}
            <div className="tv-top-panel">
                <div onClick={channelListClick} className="tv-drawer-help">
                    <FontAwesomeIcon icon={faTasks} />
                    <label>{t('List')}</label>
                </div>
                <div onClick={helpClick} className="tv-drawer-help">
                    <FontAwesomeIcon icon={faQuestionCircle} />
                    <label>{t('Help')}</label>
                </div>
                <AppxLangAvatar />
                {org === "ctal" && (
                <div className="tv-drawer-price" style={{marginRight: 8}}>
                    <div className="tv-drawer-total">
                        {t('top_bar_title')}
                    </div>
                    <Price>{planPrice}</Price>
                </div>
                )}
                <div className="tv-drawer-price">
                    <div className="tv-drawer-total">
                        {t('My Selection')}
                    </div>
                    <Price>{props.price}</Price>
                </div>
            </div>
        </div>
    );
}
